import styled from 'styled-components'

const MyDiv = styled.div`

.flex_header{
    align-items: center;
    justify-content: space-between;
}
.card-wrapper{
  position: relative;
  cursor: pointer;
  
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
   filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15))
  padding: 3rem 1rem 1rem;
//   justify-content: left;
  flex-direction: coloum;
  background: #fff;
  box-shadow: 0px 0px 20px 0px #00000017;
);
}
.notification-button{
    column-gap: 10px;
    padding: 5px 10px;
}
.avatar-icon{
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.avatar-icon .chakra-avatar__initials{
    font-size: 16px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
}
.accordion-scroll{
    height: 280px;
    overflow-y: scroll;
}
.img{
    flex-direction: row;
    }
.card_box {
  // background: white;
   padding: 15px 10px;
   border-radius: 16px;
   filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
}
.btn{
 background-color: #0B54A0;
  color: white;
  border-radius: 6px;
  padding: 8px 8px;
  &:hover {
    background-color: #0B54A0;
    color: white;
  }
.card {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    background: #fff;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  }
 /* Calendar */
 /* Calendar */
  .react-calendar {
    font-family: 'Poppins', sans-serif;
    width: 220px;
    max-width: 100%;
    font-size: 12px;
    border: none;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  }

  .react-calendar__tile {
    padding: 6px 0;
  }

  .react-calendar__navigation button {
    min-width: 28px;
    font-size: 12px;
  }

  .react-calendar__month-view__days__day--weekend {
    color: #ff6b6b;
  }
`
export default MyDiv
